import { CustomService, ImportedLocationDelta } from '../../../models/locations-models/location';
import { getFullNameForFieldID } from '../location-utils';

/**
 * Returns a string of field names that have open/accepted differences in a location.
 * @param diffs Location for which the difference fields will be converted.
 * @param getAcceptedDiffs true if you want accepted diffs, false if open
 */
export const getDifferenceFieldsAsString = (diffs: { [p: string]: ImportedLocationDelta },
                                            getAcceptedDiffs?: boolean): string => {
  const differences: string[] = [];
  let string = '';

  if (diffs) {
    for (let diff of Object.entries(diffs)) {
      if ((getAcceptedDiffs && diff[1].ignored) || (!getAcceptedDiffs && !diff[1].ignored)) {
        differences.push(diff[0]);
      }
    }
  }

  if (differences.length) {
    differences.forEach((diff, i) => (i !== differences.length - 1) ?
        string += getFullNameForFieldID(diff) + ',\n' :
        string += getFullNameForFieldID(diff));
  }

  return string;
};

/**
 * Returns a string of blacklisted fields in a location.
 * @param blacklistedFields
 */
export const getBlacklistedFieldsAsString = (blacklistedFields: string[]) => {
  let string = '';

  if (!blacklistedFields) {
    return string;
  }

  blacklistedFields.forEach((bf, i) => (i !== blacklistedFields.length - 1) ?
      string += getFullNameForFieldID(bf) + ',\n' :
      string += getFullNameForFieldID(bf));

  return string;
};

/**
 * Efficiently add / remove agGrid row CSS classes. More performant than classRules + redrawRows()
 * @param id
 * @param className
 * @param action
 */
export const addOrRemoveRowClass = (
    id: number | string,
    className: string,
    action: 'add' | 'remove') => {
  const currRowSegments = document.querySelectorAll(`[row-id="${id}"]`);
  currRowSegments.forEach(el => el.classList?.[action](className));
};

/**
 * Returns a formatted JSON object but without the surrounding curly braces.
 * @param jsonObject An object or a string.
 */
export const prettifyJSON = (jsonObject: any): string => {
  try {
    const obj = (typeof jsonObject === 'string') ? JSON.parse(jsonObject) : jsonObject;
    let pretty_str: string = JSON.stringify(obj, null, 2);
    // cut off surrounding curly braces
    if (pretty_str.startsWith('{\n') && pretty_str.endsWith('}')) {
      pretty_str = pretty_str.substring(2, pretty_str.length - 2);
    }
    return pretty_str;
  } catch (e) {
    console.error('Could not parse and prettify jsonObject ' + jsonObject, { e });
    return '';
  }
};

/**
 * Returns custom service as a string
 * @param service
 */
export const getCustomServiceAsString = (service: CustomService): string => {
  return service.serviceName +
      (service.serviceCategoryId ? ' (' + service.serviceCategoryId + ')' : '') +
      (service.serviceDescription ? ': ' + service.serviceDescription : '');
};
